module.exports = "data:image/gif;base64,R0lGODlhIAAgAMQAAPPz8/+EKYaGhlFhFRI9FjcwEjUkADUcED0YDCAcABQcAFEEBBwQCCQMABQQAD0AADEAAC0AAAgICCQAABwAABQABAwAAAQAAP///wAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAEHABgALAAAAAAgACAAAAWxICaOZGmeaKqubOu+cCzPdG0Kgn3i9eX/wKAwWJJgAshk4GKBDH/KAOEiMh6jF+SFkVAgGRRL1qecUkVYcjRdiE7XSMrFAFf6JoRydh3xNepJP3lJb2sLPg6AWj6DSIVRhxcHiksVF41Se1F9FwiUF3KYj0qcnoqCenV9FZ9QhGdXSWITrWqOGGdrFItqQEuamSJUcD8UEQ8/E5xRAxcAI0/R0i48Ojs51tna29zd3jMhADs="


//////////////////
// WEBPACK FOOTER
// ./static/images/MapIcon/Car/CHeadW_S5.gif
// module id = auT/
// module chunks = 47